module.exports = __webpack_public_path__ + "img/car_2.2008430c.png";